import React, { useRef } from 'react';
import { handleBeforeUpload, upload2AliCloud, noop } from '../../common/js/util';
import styles from "./index.module.scss";

type Props = {
  orderNumber?: string;
  category?: string;
  onUploadCompleted?: (category: string | undefined, img: any) => void
}

/**
* 添加图片按钮
* @returns 
*/
export default function UploadImgButton(options: Props) {
  const { orderNumber, category, onUploadCompleted = noop } = options;
  const inputRef = useRef<any>(null);

  const resetInputValue = () => {
    if(!inputRef.current) return;
    inputRef.current.value = null;
  }

  const onImageChoosen = e => {
    const _target = e.target;
    const fileList = _target?.files || [];
    const fileTarget = fileList[0];
    // 存在工单号则上传更新
    if (orderNumber) {
      handleBeforeUpload(fileTarget, {
        orderNumber,
        category
      }).then(ret => {
        console.log('handleBeforeUpload success >>> ', ret);
        // 上传成功回调
        onUploadCompleted(category, ret);
        resetInputValue();
      })
      .catch(err => {
        resetInputValue();
        console.error('upload error', err);
      })
    } else {
      // 工单未创建，把数据上传到云存起来再一起提交
      upload2AliCloud(fileTarget)
        .then((ret: any) => {
          console.log('upload to AliCloud success...', category, ret);
          // 上传成功回调
          onUploadCompleted(category, ret);
          resetInputValue();
        })
        .catch(err => {
          resetInputValue();
          console.error('upload alicloud error', err);
        })
    }
 }

 return (
   <div className={styles['upload-img-button']}>
     +
     <input
        ref={inputRef}
       className={styles['real-upload-input']}
       type="file"
       accept="image/*"
       onChange={onImageChoosen}
     />
   </div>
 )
}